import React, { useState } from 'react';
import CheckboxTree from 'react-checkbox-tree';

import 'react-checkbox-tree/lib/react-checkbox-tree.css';



const TestFreeTwo = () => {
  const [checked, setChecked] = useState([]);
  const [expanded, setExpanded] = useState([]);

  const nodes = [
    {
      value: 'mars',
      label: 'Mars',
      children: [
        { value: 'phobos', label: 'Phobos' },
        { value: 'deimos', label: 'Deimos' },
      ],
    },
  ];

  return (
    <div style={{ margin: 40 }}>
      <h2>Simple Checkbox Tree</h2>
      <CheckboxTree
        nodes={nodes}
        checked={checked}
        expanded={expanded}
        onCheck={setChecked}
        onExpand={setExpanded}
        showExpandAll
      />
    </div>
  );
};

export default TestFreeTwo;



// import React, { useState } from 'react';
// import { Row, Col, Container } from 'react-bootstrap';
// import { ResizableBox } from 'react-resizable';
// import 'react-resizable/css/styles.css';

// const TestFreeTwo = () => {
//   const [width, setWidth] = useState(200); // Initial width of the left column

//   const handleResize = (event, { size }) => {
//     setWidth(size.width);
//   };

//   return (
//     <Container>
//         <br />
//       <Row>
//         <ResizableBox
//           width={width}
//           height={0}
//           axis="x"
//           minConstraints={[100, 0]}
//           maxConstraints={[400, 0]}
//           onResize={handleResize}
//           resizeHandles={['e']}
//         >
//           <div style={{ height: '100%', backgroundColor: '#f8f9fa', padding: '20px' }}>
//             Left Column Content
//           </div>
//         </ResizableBox>
//         <Col style={{ flex: 1, backgroundColor: '#e9ecef', padding: '20px' }}>
//           Right Column Content
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default TestFreeTwo;




// // import React from "react";


// // export default function TestFreeTwo() {
// //   return (
// // <>

// // </>
  
// //   );
// // }
